import SPM2026ExamSchedule from "../../../assets/dashboard/SPM2026ExamSchedule.pdf";
import {
  SUBJECT_ICONS,
  SUBJECTS,
  TEACHERS,
} from "../../LandingPage/SPM2026Data";

const getSubjectColor = (name: string) =>
  SUBJECTS.find((subject) => subject.name === name)?.color ?? "#64748B";

const getSubjectIcon = (name: string) => SUBJECT_ICONS[name] ?? "";

export const SPM_NOTES = [
  {
    id: `spm_schedule`,
    subject: "SPM Exam Schedule",
    title: `SPM Exam Schedule`,
    description: "Exam Schedule for SPM 2026",
    type: "schedule",
    size: "pdf",
    uploadedAt: "20 August 2026",
    downloadUrl: SPM2026ExamSchedule,
    subjectColor: "#c10007",
    subjectEmoji: "📅",
  },
  {
    id: "spm_note_bm",
    subject: "Bahasa Melayu",
    title: "Bahasa Melayu SPM 2026 Revision Notes",
    description: "Revision notes for Bahasa Melayu SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/1ewsN4MxlO5rEG7uKXNDPcPVENBlRmhPT?usp=drive_link",
    subjectColor: getSubjectColor("Bahasa Melayu"),
    subjectEmoji: getSubjectIcon("Bahasa Melayu"),
  },
  {
    id: "spm_note_bi",
    subject: "English",
    title: "English SPM 2026 Revision Notes",
    description: "Revision notes for English SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/1TCgWfQk9NRplfkrSr30WE7rbpOjSxlQE?usp=drive_link",
    subjectColor: getSubjectColor("English"),
    subjectEmoji: getSubjectIcon("English"),
  },
  {
    id: "spm_note_sej",
    subject: "Sejarah",
    title: "Sejarah SPM 2026 Revision Notes",
    description: "Revision notes for Sejarah SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/1wqxj9sLPdb040MHbATsnQDVKAU0796Ar?usp=drive_link",
    subjectColor: getSubjectColor("Sejarah"),
    subjectEmoji: getSubjectIcon("Sejarah"),
  },
  {
    id: "spm_note_sej_spec",
    subject: "Sejarah",
    title: "Sejarah SPM 2026 Revision Notes (Special)",
    description: "Revision notes for Sejarah SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/1uSZFVrucqbkxxuRuj3VpWQh2XV-Z4Oes?usp=drive_link",
    subjectColor: getSubjectColor("Sejarah"),
    subjectEmoji: getSubjectIcon("Sejarah"),
  },
  {
    id: "spm_note_math",
    subject: "Mathematics",
    title: "Mathematics SPM 2026 Revision Notes",
    description: "Revision notes for Mathematics SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/1NLw8Olaysp7e_f0BR4AHahqKNQN2747b?usp=drive_link",
    subjectColor: getSubjectColor("Mathematics"),
    subjectEmoji: getSubjectIcon("Mathematics"),
  },
  {
    id: "spm_note_add_math",
    subject: "Additional Mathematics",
    title: "Additional Mathematics SPM 2026 Revision Notes",
    description: "Revision notes for Additional Mathematics SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/1rKKRJt5lju9QaErNCf_JnLAslLsQFM4R?usp=sharing",
    subjectColor: getSubjectColor("Additional Mathematics"),
    subjectEmoji: getSubjectIcon("Additional Mathematics"),
  },
  {
    id: "spm_note_physics",
    subject: "Physics",
    title: "Physics SPM 2026 Revision Notes",
    description: "Revision notes for Physics SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/12cbKYys3ITRW92PnUKDlChE6Ksrmhscw?usp=drive_link",
    subjectColor: getSubjectColor("Physics"),
    subjectEmoji: getSubjectIcon("Physics"),
  },
  {
    id: "spm_note_chem",
    subject: "Chemistry",
    title: "Chemistry SPM 2026 Revision Notes",
    description: "Revision notes for Chemistry SPM 2026",
    type: "notes",
    size: "Google Drive",
    uploadedAt: "2 Sept 2026",
    downloadUrl:
      "https://drive.google.com/drive/folders/10ORaGw5VPTmrgfhu6m2W05iGsQlEqGOn?usp=drive_link",
    subjectColor: getSubjectColor("Chemistry"),
    subjectEmoji: getSubjectIcon("Chemistry"),
  },
];

export const SPM_SCHEDULE = [
  {
    id: "spm_session_bm_1",
    subject: "Bahasa Melayu",
    topic: "Bahasa Melayu SPM Class Recording Part 1",
    teacherId: "spm_teacher_bm",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://www.youtube.com/watch?v=WmgBTWihyxo",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Bahasa Melayu"),
    subjectEmoji: getSubjectIcon("Bahasa Melayu"),
  },
  {
    id: "spm_session_bm_2",
    subject: "Bahasa Melayu",
    topic: "Bahasa Melayu SPM Class Recording Part 2",
    teacherId: "spm_teacher_bm",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://www.youtube.com/watch?v=eDV3ybOiAIE",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Bahasa Melayu"),
    subjectEmoji: getSubjectIcon("Bahasa Melayu"),
  },
  {
    id: "spm_session_en_1",
    subject: "English",
    topic: "English SPM Class Recording Part 1",
    teacherId: "spm_teacher_en",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/KCvpO4I_V5k",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("English"),
    subjectEmoji: getSubjectIcon("English"),
  },
  {
    id: "spm_session_en_2",
    subject: "English",
    topic: "English SPM Class Recording Part 2",
    teacherId: "spm_teacher_en",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/e5uE4-rzfVw",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("English"),
    subjectEmoji: getSubjectIcon("English"),
  },
  {
    id: "spm_session_sej_1",
    subject: "Sejarah",
    topic: "Sejarah SPM Class Recording Part 1",
    teacherId: "spm_teacher_sej",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/7dAzmUOdU88",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Sejarah"),
    subjectEmoji: getSubjectIcon("Sejarah"),
  },
  {
    id: "spm_session_sej_2",
    subject: "Sejarah",
    topic: "Sejarah SPM Class Recording Part 2",
    teacherId: "spm_teacher_sej",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/BdK633k4w8Y",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Sejarah"),
    subjectEmoji: getSubjectIcon("Sejarah"),
  },
  {
    id: "spm_session_math_1",
    subject: "Mathematics",
    topic: "Mathematics SPM Class Recording Part 1",
    teacherId: "spm_teacher_math",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "1.5 hours",
    zoomLink: "https://youtu.be/wJMgREmUJmA2",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Mathematics"),
    subjectEmoji: getSubjectIcon("Mathematics"),
  },
  {
    id: "spm_session_math_2",
    subject: "Mathematics",
    topic: "Mathematics SPM Class Recording Part 2",
    teacherId: "spm_teacher_math",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/oe15KcyeNLQ",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Mathematics"),
    subjectEmoji: getSubjectIcon("Mathematics"),
  },
  {
    id: "spm_session_add_math_1",
    subject: "Additional Mathematics",
    topic: "Additional Mathematics SPM Class Recording Part 1",
    teacherId: "spm_teacher_math",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/v02o-hTCLQw",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Additional Mathematics"),
    subjectEmoji: getSubjectIcon("Additional Mathematics"),
  },
  {
    id: "spm_session_add_math_2",
    subject: "Additional Mathematics",
    topic: "Additional Mathematics SPM Class Recording Part 2",
    teacherId: "spm_teacher_math",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/6f-xp_SkCjE",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Additional Mathematics"),
    subjectEmoji: getSubjectIcon("Additional Mathematics"),
  },
  {
    id: "spm_session_chem",
    subject: "Chemistry",
    topic: "Chemistry SPM Class Recording",
    teacherId: "spm_teacher_chem",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "1.5 hours",
    zoomLink: "https://youtu.be/wjxWgfyzsrs",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Chemistry"),
    subjectEmoji: getSubjectIcon("Chemistry"),
  },
  {
    id: "spm_session_physics",
    subject: "Physics",
    topic: "Physics SPM Class Recording",
    teacherId: "spm_teacher_phy",
    date: "Anytime",
    day: "Any day",
    time: "Self-paced",
    duration: "2 hours",
    zoomLink: "https://youtu.be/WpHLrLTLI5o",
    zoomId: "-",
    zoomPassword: "-",
    status: "recordings",
    subjectColor: getSubjectColor("Physics"),
    subjectEmoji: getSubjectIcon("Physics"),
  },
];
